export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'createdAt',
    label: 'Login date',
    sortable: false,
  },
  {
    name: 'platform',
    label: 'Device OS',
    sortable: false,
  },
  {
    name: 'browser',
    label: 'Browser',
    sortable: false,
  },
  {
    name: 'ip',
    label: 'IP address',
    sortable: false,
  },
];

export const columnsLabels = {};

export const schema = {};

export const filtersSchema = [];
